export enum EventStepType {
    SourceAlarmTriggered = 1101,
    SourceAlarmHasNoMeasure = 1602,

    TransferSavedToDisk = 2101,

    TransferCheckStarted = 2102,
    TransferAlarmStarted = 2103,

    TransferCheckSuccess = 2104,
    TransferAlarmSuccess = 2105,

    TransferCheckFailedAlarmExceptionActive = 2601,

    TransferSavedToDiskFailed = 2901,

    TransferCheckFailedInvalidCredentials = 2902,
    TransferCheckFailedServerNotAvailable = 2903,

    TransferAlarmFailed = 2904,
    TransferAlarmFailedServerNotAvailable = 2905,

    QueueInserted = 3101,
    QueueConsumed = 3102,
    QueueConsumeFailed = 3701,

    ClassificationStarted = 4101,
    ClassificationFinished = 4102,

    ClassificationAborted = 4601,

    DecisionMakingStarted = 5101,
    DecisionMakingFinished = 5102,

    DecisionMakingAborted = 5601,

    MeasureTakingStarted = 6101,
    MeasureTakingFinished = 6102,
    MeasureTakingStartSirenCommandSent = 6103,
    MeasureTakingStopSirenCommandSent = 6104,
    MeasureTakingStartSpeakerCommandSent = 6105,
    MeasureTakingStopSpeakerCommandSent = 6106,
    MeasureTakingPhoneCallGuard = 6107,
    MeasureTakingPhoneCallContact = 6108,
    MeasureTakingSms = 6109,
    MeasureTakingSirenStarted = 6110,
    MeasureTakingSirenStopped = 6111,
    MeasureTakingSpeakerStarted = 6112,
    MeasureTakingSpeakerStopped = 6113,

    MeasureTakingAborted = 6601,
    InformationAdded = 6602,
}
